import { TabView } from "components/LayoutOptions/layoutOptionsStyles";
import Split from "react-split";
import styled from "styled-components";

export const Wrapper = styled.div`
    width: 100%;
    height: 91%;
`;

export const Option = styled.div`
    display: flex;
    color: white;
    justify-content: center;
    font-size: 48px;
    cursor: pointer;
    margin-bottom: 20px;

    :hover {
        filter: brightness(95%);
    }
`;

export const HorizontalSplit = styled(Split)<{
    $gutterConfig?: {
        hidden?: boolean;
    };
}>`
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 100vw;
    height: 100%;

    gap: ${({ $gutterConfig }) => ($gutterConfig?.hidden ? "0px" : "5px")};

    & > .gutter {
        position: relative;
        align-self: center;

        width: 5px;
        min-width: 5px;
        height: 60px;

        border-radius: 10px;
        background-color: rgb(170, 170, 170);
        background-repeat: no-repeat;
        background-position: 50%;

        &:hover {
            cursor: col-resize;
        }

        ${({ $gutterConfig }) =>
            $gutterConfig?.hidden &&
            `
                opacity: 0;
                pointer-events: none;
                width: 0 !important;
                min-width: 0 !important;
                margin: 0 !important;
            `}
    }
`;

export const TableWrap = styled(TabView)`
    position: relative;
    background: inherit;
    border: none;
    border-radius: unset;
    font-size: 48px;
    line-height: initial;
    display: flex;
    align-items: flex-start;
    width: 100%;
    height: 100%;
`;

export const MultipleTablesWrap = styled(Option)`
    width: 100%;
    height: 100%;

    :hover {
        filter: none;
    }
`;

export const VerticalSplit = styled(Split)<{
    $gutterConfig?: {
        top?: number;
        hidden?: boolean;
    };
}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    & > .gutter {
        position: relative !important;
        margin: 0 !important;

        height: 5px !important;
        width: 60px !important;

        align-self: center;

        border-radius: 10px;
        background-color: rgb(170, 170, 170);
        cursor: row-resize;
        flex-shrink: 0;
        z-index: 10;
        ${({ $gutterConfig }) =>
            $gutterConfig?.hidden && `display: none !important;`}

        ${({ $gutterConfig }) =>
            typeof $gutterConfig?.top === "number"
                ? `top: ${$gutterConfig.top}px !important;`
                : ""}
    }
`;
